import { Injectable } from '@angular/core';
import { LoyaltyProgramApiService } from '@features/loyalty-program/services/loyalty-program-api/loyalty-program-api.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { HttpError, LoyaltyProgram } from '@rd/types';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as redeemCashLoyaltyActions from '../actions/redeem-cash-loyalty-program.actions';

@Injectable()
export class RedeemCashLoyaltyProgramEffects {
  constructor(
    private actions$: Actions,
    private loyaltyProgramApiService: LoyaltyProgramApiService,
  ) {}

  loadRedeemCashLoyaltyPrograms$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        redeemCashLoyaltyActions.RedeemCashLoyaltyProgramActionTypes
          .LOAD_REDEEM_CASH_LOYALTY_PROGRAM,
      ),
      switchMap(() => {
        return this.loyaltyProgramApiService
          .getRedeemCashLoyaltyPrograms()
          .pipe(
            map((rcLoyaltyPrograms: LoyaltyProgram[]) => {
              return new redeemCashLoyaltyActions.LoadRedeemCashLoyaltyProgramSuccess(
                rcLoyaltyPrograms,
              );
            }),
            catchError((error: HttpError) =>
              of(
                new redeemCashLoyaltyActions.LoadRedeemCashLoyaltyProgramFailed(
                  error,
                ),
              ),
            ),
          );
      }),
    ),
  );
}
